import type { ElementType, PropsWithChildren } from "react";

import clsx from "clsx";

/**
 * Standard vertical spacing between a page's major sections. Kept as a single
 * source of truth so every page shares the same rhythm instead of each one
 * picking its own `gap-*` (which is how Earnings/PerformanceReport drifted
 * apart). Horizontal page margins stay owned by the app shell (`AppLayout`),
 * not this component.
 */
const GAP = {
  sm: "gap-4",
  md: "gap-6",
  lg: "gap-8",
} as const;

type PageSectionGap = keyof typeof GAP;

type PageSectionProps = PropsWithChildren<{
  /** Vertical spacing between direct children. Defaults to `lg` (32px). */
  gap?: PageSectionGap;
  /** Rendered element. Defaults to `div`. */
  element?: ElementType;
  className?: string;
}>;

export const PageSection = ({
  children,
  gap = "lg",
  element: Element = "div",
  className,
}: PageSectionProps) => (
  <Element className={clsx("grid w-full grid-cols-1", GAP[gap], className)}>
    {children}
  </Element>
);
